import Vue from 'vue'
import { ValidationProvider, extend, localize } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'
import fr from 'vee-validate/dist/locale/fr.json'

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

// with typescript
for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  })
}

// Install English and French locales.
localize({
  en,
  fr
})

Vue.component('ValidationProvider', ValidationProvider)



// WEBPACK FOOTER //
// ./src/plugins/utilities/vee-validate.js